$(document).on('ready', () => {

	$('.teamlink').on('click', function(event) {
		event.preventDefault();
		event.stopPropagation();
		$target = $(this).attr('data-target');

		switchToTargetTeamMember($target)
	});

	$('.teamoverlay').on('click', function(e) {
		if (e.target !== this)
			return;
		$(this).removeClass('display');
	});

	$('.close-pop').on('click', function() {
		$('.teamoverlay').removeClass('display');
	});

	$('.team-info-card').on('click', function() {
		$target = $(this).attr('data-target');

		$('.teamoverlay').addClass('display');
		switchToTargetTeamMember($target);
	})
});

function switchToTargetTeamMember($target) {
	$('.overlay-card.display').removeClass('display');
	$('.overlay-card[data-id="' + $target + '"]').addClass('display');
}